import { combineReducers } from "redux";
import { getFailureActionType, getSuccessActionType } from "../utils";
import { FETCH_COMMUNICATION_METHODS_REQUEST } from "./constants";
import { Action, CommunicationMethodsState } from "./types";

function item(state: CommunicationMethodsState = {}, action: Action): CommunicationMethodsState {
  switch (action.type) {
    case getSuccessActionType(FETCH_COMMUNICATION_METHODS_REQUEST):
      return action.payload;

    default:
      return state;
  }
}

function isFetching(state: boolean = false, action: Action): boolean {
  switch (action.type) {
    case FETCH_COMMUNICATION_METHODS_REQUEST:
      return true;
    case getSuccessActionType(FETCH_COMMUNICATION_METHODS_REQUEST):
    case getFailureActionType(FETCH_COMMUNICATION_METHODS_REQUEST):
      return false;

    default:
      return state;
  }
}

export const communicationMethods = combineReducers({ item, isFetching });
